module.exports = __webpack_public_path__ + "static/work04_02-146d91b1571c9276b507e042e836986d.jpg";